import { gql } from "gql";

export const GET_ALL_PERSONS_EXTENDED = gql(/* GraphQL */ `
  query GetAllPersonsExtended(
    $personFilter: PersonSearchInput
    $pageableRequest: PageRequest
  ) {
    findPersons(
      personFilter: $personFilter
      pageableRequest: $pageableRequest
    ) {
      content {
        ...PersonLabel
        ...PersonPositionAndOrganization

        personType {
          value {
            value
          }
        }
      }
      total
    }
  }
`);
